// Operator-only navigation gating, shared by the sidebar (Navbar) and the
// command palette so the two menus can never disagree.
//
// The `admin` group is the platform back-office: entries there are rendered
// exclusively for platform admins. The flag is resolved server-side
// (PLATFORM_ADMIN_EMAILS env allowlist OR a back-office grant) and surfaced
// via /auth/me as `is_admin` — the UI never decides adminship itself.
//
// Hiding menu entries is a UX measure, not the security boundary: the
// /api/admin/platform/* endpoints are gated server-side and the
// /admin/platform route has its own guard in App.js.

// Pages that only exist on our cloud: paying us and issuing licence keys. A
// self-hosted install is licensed from the customer's cloud account, so it
// hides them (and CloudOnly sends their routes to the dashboard).
export const CLOUD_ONLY_PATHS = ['/billing', '/self-hosted'];

export function visibleNavItems(items, user, { selfHosted = false } = {}) {
  const isAdmin = Boolean(user?.is_admin);
  return items.filter((item) => {
    if (item.group === 'admin' && !isAdmin) return false;
    if (selfHosted && CLOUD_ONLY_PATHS.includes(item.href || item.path)) return false;
    return true;
  });
}
